/**
 * citiesApi — Städteseiten-Relaunch (09.2026)
 *
 * GET /api/v2/cities und GET /api/v2/cities/:id existieren im Backend
 * (Api::V2::CitiesController), stehen aber noch nicht im generierten
 * OpenAPI-Kontrakt (@heliumtracker/api-types). Gleiches Escape-Hatch-Muster
 * wie features/wallets/api/walletApi.ts: `apiClient as any` statt rohem
 * fetch() (fetch() ist in features/ per Lint-Regel verboten).
 */
import apiClient from '../../lib/api-client'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const client = apiClient as any

export type CityListEntry = {
  id: string | number
  /** Numerische City.id — Route-Parameter für /cities/:id (`id` oben ist nur ein Anzeige-Slug). */
  city_id: number
  name: string
  country_code: string
  hotspots_count: number
  active_hotspots_count: number
  online_pct: number
  total_rewards_30d_hnt: number
}

export type CityListResponse = {
  data: CityListEntry[]
  meta: { page: number; per_page: number; count: number; pages: number }
}

export type CityHotspotEntry = {
  id: number
  address: string | null
  name: string | null
  online: boolean
  rewards_24h: number
  rewards_7d: number
  rewards_30d: number
}

export type CityDetail = {
  id: number
  name: string
  country_code: string
  hotspots_count: number
  active_hotspots_count: number
  online_pct: number
  total_rewards_24h_hnt: number
  total_rewards_7d_hnt: number
  total_rewards_30d_hnt: number
  hotspots: CityHotspotEntry[]
}

export type CityDetailResponse = {
  data: CityDetail
  meta: { page: number; per_page: number; count: number; pages: number }
}

export async function fetchCities(params: {
  sort?: string
  order?: string
  page?: number
  per_page?: number
}): Promise<{ data?: CityListResponse; error?: unknown; response: Response }> {
  return client.GET('/api/v2/cities', { params: { query: params } })
}

export async function fetchCity(
  id: string,
  params: { page?: number; per_page?: number; filter?: string } = {},
): Promise<{ data?: CityDetailResponse; error?: unknown; response: Response }> {
  return client.GET('/api/v2/cities/{id}', {
    params: { path: { id }, query: params },
  })
}
